var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyLink",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.copyLink($event)}}},[_c('v-icon',[_vm._v("content_copy")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }